import React, {useState, useEffect} from 'react';
import { faList, faPlus, faUser, faBriefcase, faFile } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Link } from 'react-router-dom';
import "../global/components/scroll-bar.css";
import { getCount } from '../utils/api-services/dashboard';
import TopJobPosts from '../job/components/TopJobPosts';
import TopTopics from '../topic/components/TopTopics';

const Dashboard = () => {

    const [jobCount, setJobCount] = useState(0);
    const [profileCount, setProfileCount] = useState(0);
    const [topicCount, setTopicCount] = useState(0);
    const [width, setWidth] = useState(window.innerWidth);
    const isMobile = width <= 768;

    useEffect(()=>{
        loadCount();
    }, [])

    const loadCount = async () => {
        const res = await getCount();
        if(res?.Success){
            const obj = res.Data;
            setJobCount(obj.JobCount);
            setProfileCount(obj.ProfileCount);
            setTopicCount(obj.TopicCount);
        }
    }

    const cards = [
        {
            Icon: "/images/cv2.png", 
            Title: "Profile", 
            Count: profileCount,
            Links: [
                {Icon: faUser, Label: "Career Profile", Url: "/cv/me"},
                {Icon: faFile, Label: "CV", Url: "/cv/me"},
                {Icon: faBriefcase, Label: "Projects", Url: "/cv/me"}
            ]
        },
        {
            Icon: "/images/job2.png", 
            Title: "Job", 
            Count: jobCount,
            Links: [
                {Icon: faList, Label: "Job Listing", Url: "/job/list/1"},
                {Icon: faList, Label: "My Job Postings", Url: "/jobs/me"},
                {Icon: faPlus, Label: "New Job Posting", Url: "/job/new"},
            ]
        },
        {
            Icon: "/images/topic2.png", 
            Title: "Topic", 
            Count: topicCount,
            Links: [
                {Icon: faList, Label: "Topics", Url: "/topic/list/1"},
                {Icon: faList, Label: "My Topics", Url: "/topics/me"},
                {Icon: faPlus, Label: "New Topic", Url: "/topic/new"},
            ]
        }
    ];

    const styles = {
        page:{
            paddingTop: 40
        },
        header:{
            wrap:{
                display: "flex",
                marginBottom: 20
            },
            title: {
                color: "#666",
                fontSize: 24,
                fontWeight: 500
            }
        },
        card: {
            wrap: {
                display: 'flex',
                alignItems: 'stretch',
                marginBottom: 60,
                overflowY: isMobile? 'scroll': 'none'
            },
            item: {
                background: '#fff',
                minWidth: 200,
                marginRight: 20,
                border: '1px solid #ccc',
                borderRadius: 5
            },
            head:{
                display: 'flex',
                alignItems: 'center',
                position: 'relative',
                paddingTop: 10,
                paddingBottom: 10,
                paddingLeft: 10,
                paddingRight: 10,
            },
            icon: {
                width: 36,
                marginRight:10,
            },
            title: {
                color: "#333",
                marginRight: 10,
                fontSize: 19,
                fontWeight: 600
            },
            count: {
                color: "#ccc",
                fontSize: 24,
                fontWeight: 600,
                position: 'absolute',
                top: 6,
                right: 20
            },
            link:{
                wrap:{
                    paddingTop: 10,
                    paddingBottom: 5,
                    paddingLeft: 10,
                    paddingRight: 10,
                },
                item:{
                    display: 'flex',
                    alignItems: 'center',
                    marginBottom: 15
                },
                icon: {
                    color: '#ccc',
                    marginRight: 15,
                    fontSize: 14
                },
                url: {
                    color: '#666',
                    fontSize: 14,
                    textDecoration: 'none'
                }
            },

        },
        topJobs: {
            background:'#fff', 
            marginBottom: 60,
        },
        topTopics: {
            background:'#fff', 
            marginBottom: 60,
        },
    }

    const numberOne = 1;
    const numberTwo = 3;
    const total = numberOne + numberTwo;
    
    return (
        <div style={styles.page}>
            <div className='container'>
                <div className='row'>
                    <div className='col-md-2'></div>
                    <div className='col-md-10'>

                        <div style={styles.header.wrap}>
                            <h2 style={styles.header.title}>Dashboard</h2>
                        </div>

                        <div style={styles.card.wrap} className='hide-scroll-bar'>
                            {cards.map(itm => (
                                <div style={styles.card.item}>
                                    <div style={styles.card.head}>
                                        <img src={itm.Icon} style={styles.card.icon} />
                                        <h4 style={styles.card.title}>{itm.Title}</h4>
                                        <div style={styles.card.count}>{itm.Count}</div>
                                    </div>
                                    <hr style={{margin: 0}} />
                                    <div style={styles.card.link.wrap}>
                                        {itm.Links.map(lnk => (
                                            <div style={styles.card.link.item}>
                                                <FontAwesomeIcon icon={lnk.Icon} style={styles.card.link.icon} />
                                                <a href={lnk.Url} style={styles.card.link.url}>{lnk.Label}</a>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            ))}
                        </div>

                        <div style={styles.topJobs}>
                            <TopJobPosts />
                        </div>

                        <div style={styles.topTopics}>  
                            <TopTopics />
                        </div>

                    </div>
                </div>
            </div>
        </div>
    )
}

export default Dashboard